import { useTranslation } from "react-i18next";
import   "./Login.css";
import logoIcon from "../../base/assets/icons/logo.svg";
import trainIcon from "../../base/assets/icons/iconfinder_train_2875945.svg";

const ForgotPasswordSuccess: React.FC = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={'background'}> </div>
      <div className={'wrapper'}>
        <div className={'registerSuccessBox'}>
          <img
            tabIndex={0}
            className={'logo'}
            width="152"
            src={logoIcon}
            alt={t("Header-Logo-alt")}
          />
          <h1 className={'header'}>{t("Login-register-success-header")}</h1>
          <img
            className={'register__successLogo'}
            src={trainIcon}
            alt={t("Success-Logo-alt")}
          />
          <h3 tabIndex={0} className={'register__success'}>
            {t("Login-main-success-message")}
          </h3>
          <span tabIndex={0} className={'register__successComment'}>
            {t("Login-sub-success-message")}
          </span>
        </div>
      </div>
    </>
  );
};
export default ForgotPasswordSuccess;
